import React from 'react';
import PropTypes from 'prop-types';

import {reduxForm, Field} from 'redux-form';
import FieldText from '../fields/fieldText/FieldText';
import Button from '../button/Button';
import {FormattedMessage, injectIntl} from 'react-intl';

@injectIntl
@reduxForm({
  form: 'resetPassword',
  validate: ({password = '', passwordRepeated = ''}) => ({
    password: password.length >= 4 ? undefined : <FormattedMessage id="section.auth.password.short"/>,
    passwordRepeated: password === passwordRepeated ? undefined : <FormattedMessage id="section.auth.password.must-match"/>
  })
})
export default class ResetPasswordForm extends React.PureComponent {
  render() {
    const {intl, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field name="userId" type="hidden" component="input"/>
        <Field name="token" type="hidden" component="input"/>

        <Field
          name="password"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.new'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="passwordRepeated"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.repeat'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Button full filled loading={submitting} disabled={submitting}>
          {intl.formatMessage({id: 'section.auth.password.action'})}
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/ResetPasswordForm.js